module.exports = __webpack_public_path__ + "static/media/bbb-karaoke.8955640a.png";